import styled from 'styled-components';

export const AnswerButton = styled.button`
  width: 100%;
  min-height: 64px;
  padding: 15px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid ${p => p.$selected ? p.theme.palette.blue.main : p.theme.palette.colors.borderSoft};
  border-radius: 14px;
  background: ${p => p.$selected ? p.theme.palette.colors.badgeMuted : p.theme.palette.colors.buttonGhost};
  color: ${p => p.theme.palette.colors.text};
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: ${p => p.theme.palette.blue.main};
    background: ${p => p.theme.palette.colors.badgeMuted};
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid ${p => p.theme.palette.blue.main};
    outline-offset: 3px;
  }

  @media (max-width: 480px) {
    min-height: 58px;
    padding: 13px 14px;
  }
`;

export const SelectionControl = styled.span`
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${p => p.$selected ? p.theme.palette.blue.main : p.theme.palette.colors.subdued};
  border-radius: ${p => p.$multiple ? '6px' : '50%'};
  background: ${p => p.$selected ? p.theme.palette.blue.main : 'transparent'};
  transition: border-color 0.2s ease, background 0.2s ease;

  &::after {
    content: '';
    width: ${p => p.$multiple ? '8px' : '7px'};
    height: ${p => p.$multiple ? '4px' : '7px'};
    border-radius: ${p => p.$multiple ? '0' : '50%'};
    border-color: ${p => p.theme.palette.blue.contrastText};
    border-style: solid;
    border-width: ${p => p.$multiple ? '0 0 2px 2px' : '0'};
    background: ${p => p.$multiple ? 'transparent' : p.theme.palette.blue.contrastText};
    opacity: ${p => p.$selected ? 1 : 0};
    transform: ${p => p.$multiple ? 'translateY(-1px) rotate(-45deg)' : 'none'};
    transition: opacity 0.2s ease;
  }
`;

export const AnswerText = styled.span`
  color: inherit;
  font-family: Lato;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
`;
